<template>
  <div>
    <div class="area-new row">
      <div class="align-right col-12">
        <button tabindex="0" @click="openDialog()" type="button" class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
          <span class="q-focus-helper"></span>
            <span class="q-btn__wrapper col row q-anchor--skip">
              <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                <i aria-hidden="true" role="presentation" class="q-icon notranslate material-icons q-pr-md jt-data-table-button photos-btn">add_to_photos</i>
                {{$gettext("NEW")}}
              </span>
          </span>
        </button>
      </div>
    </div>
    <div>
      <table class="tabela">
        <thead>
          <tr>
            <th class="align-column" >{{$gettext("CRM_CONTRACT_NUMBER")}}</th>
            <th class="align-column" >{{$gettext("CONTRACT_CLIENT")}}</th>
            <th class="align-column" >{{$gettext("CLIENT_DOCUMENT")}}</th>
            <th class="align-column" >{{$gettext("COMPANY_UPPERCASE")}}</th>
            <th class="align-column" ></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in contracts" :key="index" >
            <td class="align-column" >{{ row.contractNumberCrm }}</td>
            <td class="align-column" ><span class="person-name-wrap">{{ row.client.personName }}</span></td>
            <td class="align-column" >{{ row.client.personDocument }}</td>
            <td class="align-column" >{{ row.client.fantasyName }}</td>
            <td class="mdi mdi-pencil mdi-24px custom-cursor" @click="setContractToUpdatePage(index)"></td>
            <td class="mdi mdi-delete mdi-24px custom-cursor" @click="removeContract">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
          <div class="col-3">
              <q-btn class="full-width" color="info" @click="conclude">
                {{ $gettext("CONCLUDE") }}
              </q-btn>
          </div>
    </div>
    <q-dialog ref="popUpContract" v-if="flModal" v-model="flModal" @hide="onHideHandler" maximized >
      <q-layout
        view="Lhh lpR fff"
        container
        class="bg-white modal-medium"
      >
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("CONTRACTS")
            }}</q-toolbar-title>
            <q-btn
              @click="resetContractToLastSave"
              flat
              round
              dense
              size="1.5em"
              icon="cancel"
            />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <ContractRegisterPage :updateContract = updateContract @confirm="addContract($event)"></ContractRegisterPage>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtCompositionFormModal } from 'jtech-webcomps'
import { repository } from 'jtech'
import ContractDetail from '../contract/ContractDetail'
import ContractUpdate from '../contract/ContractUpdate'
import ContractPageTable from '../contract/ContractPageTable'
import ContractRegisterPage from '../contract/ContractRegisterPage.vue'
import { messageBox } from 'src/jtech'

const { pageDetail, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [pageDetail, JtCompositionFormModal],
  name: 'ContractClient',
  components: { CrudLayoutSearch, ContractDetail, ContractUpdate, ContractPageTable, ContractRegisterPage },
  props: {
    id: String,
    interface: String,
    name: String,
    client: {},
    contracts: []
  }
})
class ContractClientRegisterPage extends Vue {
  flModal = false;
  updateContract = {};

  mounted () {
  }

  addContract (contract) {
    contract.client = this.client
    this.contracts.push(contract)
    this.closeDialog()
  }

  openDialog () {
    if (this.contracts && this.contracts.length > 0) {
      messageBox.warn(this.$gettext('CONTRACT_AREALDY_INSERTED'))
      return
    }
    this.flModal = true
  }

  closeDialog () {
    this.flModal = false
  }

  resetContractToLastSave () {
    this.closeDialog()
    if (this.updateContract && Object.keys(this.updateContract).length > 0) {
      this.contracts.push(this.updateContract)
    }
  }

  setContractToUpdatePage (index) {
    this.updateContract = { ...this.contracts[index] }
    this.contracts.splice(index, 1)
    this.flModal = true
  }

  conclude () {
    if (!this.contracts || this.contracts.length === 0) {
      messageBox.warn(this.$gettext('CONTRACT_NOT_INSERTED'))
      return
    }
    this.$emit('conclude', this.contracts)
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ContractUpdate
  }

  get pageDetail () {
    return ContractDetail
  }

  get pageTable () {
    return ContractPageTable
  }

  removeContract () {
    this.contracts = []
    this.updateContract = {}
    this.$emit('removeContract', this.contracts)
  }
}
export default ContractClientRegisterPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.contract-client {
  .buttons-top-crud {
    padding: 10px 14px;
  }

  .q-table th, .q-table td {
    padding: 0px 10px !important;
  }

}

@media only screen and (max-height: 750px) {
  .contact-client {
    .table-crud .jt-datatable {
      padding-bottom: 0px;
    }
  }
}

.tabela {
  width: 100%;
  border-collapse: collapse;
  margin: 20px auto;
}

.tabela th, .tabela td {
  padding: 12px;
  text-align: left;
}

.tabela th {
  background-color: #F2F4F5;
  border-bottom: 2px solid #dddddd;
}

.tabela tr:hover {
  background-color: #f0f0f0;
}

.table-row-divider {
  border-bottom: 1px solid #ddd;

}
.custom-cursor {
  cursor: pointer;
}
.area-new {
  margin-bottom: 20px;
}
.align-right {
  text-align: right;
}
.person-name-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 300px;
}
</style>
